import { useTranslation } from 'react-i18next';
import { HiArrowUpRight } from 'react-icons/hi2';
import { utilService } from '../services/util.service';
import { ISearchProps } from './app-header/app-header';

export function MobileSearchTeaser({ onChangeModule, onChangeIsExpanded, searchBy }: ISearchProps) {
  const { t } = useTranslation();

  const handleSectionClick = () => {
    onChangeIsExpanded(true);
    onChangeModule('location');
  };

  const handleSectionKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleSectionClick();
    }
  };

  const locationText =
    searchBy.city && searchBy.state
      ? `${searchBy.city}, ${searchBy.state}`
      : searchBy.state || searchBy.city || t('mobile-search-teaser-location-anywhere');

  const dateText =
    searchBy.startDate && searchBy.endDate
      ? utilService.formatDateMMMd(searchBy)
      : t('mobile-search-teaser-date-any-week');

  return (
    <div
      onClick={handleSectionClick}
      onKeyDown={handleSectionKeyDown}
      className="mobile-search-teaser"
      role="button"
      tabIndex={0}
      aria-label={t('mobile-search-form-main-title')}
    >
      <div className="mobile-search-teaser__text">
        <p className="mobile-search-teaser__primary">
          {locationText}
          <span className="mobile-search-teaser__dot">·</span>
          {dateText}
        </p>
      </div>
      <button
        type="button"
        className="mobile-search-teaser__action"
        onClick={(e) => {
          e.stopPropagation();
          handleSectionClick();
        }}
        aria-label={t('search-module-button-search')}
      >
        <HiArrowUpRight size={18} />
      </button>
    </div>
  );
}
